(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_delivery-checker"] && !Shopify.designMode) return;
  try {
    (function(){
    document.querySelectorAll('.hz-delivery-checker').forEach(function(checker){
      if(checker.dataset.init) return;
      checker.dataset.init = '1';
      var input  = checker.querySelector('.hz-pincode-input');
      var btn    = checker.querySelector('.hz-check-btn');
      var result = checker.querySelector('.hz-delivery-result');
      if(!input||!btn||!result) return;
      input.addEventListener('input', function(){ this.value = this.value.replace(/\D/g,''); });
      input.addEventListener('keydown', function(e){ if(e.key==='Enter') btn.click(); });
      btn.addEventListener('click', function(){
        var val = input.value.trim();
        if(!/^\d{6}$/.test(val)){
          result.className='hz-delivery-result hz-error';
          result.innerHTML='<span class="hz-result-icon">✕</span><span>Please enter a valid 6-digit pincode.</span>';
          return;
        }
        var today=new Date(), min=new Date(today), max=new Date(today);
        min.setDate(today.getDate()+3);
        max.setDate(today.getDate()+5);
        var opts={day:'numeric',month:'short',weekday:'short'};
        result.className='hz-delivery-result hz-success';
        result.innerHTML='<span class="hz-result-icon">✓</span><span>Delivery between <strong>'+min.toLocaleDateString('en-IN',opts)+'</strong> & <strong>'+max.toLocaleDateString('en-IN',opts)+'</strong></span>';
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_price-actions"] && !Shopify.designMode) return;
  try {
    (function () {

  var MC_WL_KEY = 'mc_wishlist_v1';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(MC_WL_KEY) || '[]'); } catch(e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(MC_WL_KEY, JSON.stringify(list));
  }

  function syncWishlistBtn(btn) {
    var variantId = String(btn.dataset.variantId || '');
    var productId = String(btn.dataset.productId || '');
    var wl = getWishlist();
    var found = wl.some(function(i) {
      return String(i.variantId) === variantId || String(i.productId) === productId;
    });
    if (found) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
  }

  function initWishlistBtns() {
    document.querySelectorAll('.nitra-wishlist-btn').forEach(function (btn) {
      /* Sync state every time (covers back navigation) */
      syncWishlistBtn(btn);

      if (btn.dataset.init) return;
      btn.dataset.init = '1';

      btn.addEventListener('click', function () {
        var variantId = String(btn.dataset.variantId || '');
        var productId = String(btn.dataset.productId || '');
        var wl  = getWishlist();
        var idx = wl.findIndex(function(i) {
          return String(i.variantId) === variantId || String(i.productId) === productId;
        });

        if (idx > -1) {
          wl.splice(idx, 1);
          btn.classList.remove('is-active');
        } else {
          /* Grab best available image */
          var imgSrc = btn.dataset.image || '';

          wl.unshift({
            variantId: variantId,
            productId: productId,
            title:     btn.dataset.title || document.title,
            image:     imgSrc,
            url:       btn.dataset.url || window.location.pathname
          });
          btn.classList.add('is-active');
        }

        saveWishlist(wl);
        if (window.mcUpdateWishlistBadge) window.mcUpdateWishlistBadge();
      });
    });
  }

  /* ── Init on load ── */
  initWishlistBtns();

  /* ── Fix: back/forward cache — re-sync on every pageshow ── */
  window.addEventListener('pageshow', function () {
    initWishlistBtns();
    if (window.mcUpdateWishlistBadge) window.mcUpdateWishlistBadge();
  });

  /* ── Share ── */
  function showToast(msg) {
    var toast = document.querySelector('.nitra-share-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'nitra-share-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 2500);
  }

  document.querySelectorAll('.nitra-share-btn').forEach(function (btn) {
    if (btn.dataset.init) return;
    btn.dataset.init = '1';
    btn.addEventListener('click', function () {
      var url   = btn.dataset.url;
      var title = btn.dataset.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function(){});
      } else {
        navigator.clipboard.writeText(url).then(function () {
          showToast('Link copied to clipboard!');
        }).catch(function () {
          showToast('Copy this link: ' + url);
        });
      }
    });
  });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-description"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.nitra-desc__trigger').forEach(function (trigger) {
    if (trigger.dataset.init) return;
    trigger.dataset.init = '1';

    var body = trigger.nextElementSibling;

    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !expanded);
      body.setAttribute('aria-hidden', expanded);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-offers"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".special-offers__copy").forEach(function(btn) {
    btn.addEventListener("click", function() {
      var code = btn.dataset.code;
      navigator.clipboard.writeText(code).then(function() {
        btn.classList.add("copied");
        btn.querySelector(".label").textContent = "Copied!";
        setTimeout(function() {
          btn.querySelector(".label").textContent = code;
          btn.classList.remove("copied");
        }, 2000);
      });
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
